import { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'

// Redux Action
import * as ACTIONS from '../../services/redux/actions'


export const getLocAndVIDHDLR = (records = []) => {
    const locationKeys = ['location', 'start_loc', 'end_loc']; 

    const locsWithVID = records?.length && records.reduce((acc, d) => {
        locationKeys.forEach(key => {
            if (d[key]) acc.push({ vid: d.vid, ...d[key]});
        });
        return acc;
    }, []);

    return locsWithVID
}


export const getAddressHDLR = (locations, retryNum = 10) => {

    const dispatch = useDispatch()
    const isInit = useRef(false)

    const fetchAddresses = (list, retryNum) => {
        if(retryNum === 0) return;

        dispatch(ACTIONS.v3_locationTracking.get_batch_coordinate_address_request(list, (data) => {
            const missingAddresses = data.filter(d => !d.address) || []

            if(missingAddresses.length) {
                setTimeout(() => fetchAddresses(missingAddresses, --retryNum), 1500)
            }
        }))
    }

    const map = new Map()

    useEffect(() => {
        if(!locations || !locations.length) return;
        
        if(!isInit.current) {
            locations.forEach(l => {
                const key = `${Number(l.lat)},${Number(l.lon)}`
                if(!map.has(key)) map.set(key, l)
            })
        
            const uniqueList = Array.from(map.values())
            fetchAddresses(uniqueList, retryNum) 

            isInit.current = true
        }
        
    }, [locations])

}